import React from "react";
import { View, Pressable } from "react-native";
import { scale, verticalScale } from "@utils/scale";
import Text from "@components/AppText";
import { colors } from "@constants/theme";
import Plus from "@assets/svg/WithdrawMoney/Cross";

export class Fab extends React.Component {
  render() {
    return (
      <Pressable
        {...this.props}
        style={{
          backgroundColor: "rgba(228, 0, 70, 1)",
          width: scale(56),
          position: "absolute",
          bottom: 60,
          right: 20,
          height: scale(56),
          borderRadius: scale(28),
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Plus color={colors.white} />
      </Pressable>
    );
  }
}
